import Axios from "axios";
import authHeader from "../../../services/auth/auth-header";
import { loadStripe } from "@stripe/stripe-js";

const upgradeAccount = (userData) => async (dispatch) => {
  let apiCallRequest = {
    url: "https://backendpaygo.thetalent.games/gcp/pay/create-checkout-session",
    // url: "http://192.168.1.118:3000/gcp/pay/create-checkout-session",
    data: userData,
    config: {
      headers: authHeader(),
    },
  };

  const stripe = await loadStripe(
    // "pk_test_51M9QuvHqffwa6qOZr4XSwm5hocMBF9uEWzlgzFCAUD65JGSgkOulnuVEXAHfFCORSQg8EfCs38SnrAxVbYBu49rg00QTvw4lOG"
    "pk_live_51M9QuvHqffwa6qOZA8ytMOq1mYycFkUxRzxLBlpm3HObTZV5izuWjwTLNCsq9IIm4DU2wQVMk2flB7HOLQDezitT007RQY6fcA"
  );
  Axios.post(apiCallRequest.url, apiCallRequest.data, apiCallRequest.config)
    .then((res) => {
      let session = res.data && res.data.session;
      let id = session.id;
      sessionStorage.setItem("id", JSON.stringify(id));
      stripe.redirectToCheckout({
        sessionId: session.id,
      });
    })
    .catch((err) => {
      console.log(err, " here is");
    });
};

export { upgradeAccount };
